import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { formatMoney } from "infra/helpers/number";

export default function FooterTable({
  totalItens,
  total,
}: {
  totalItens?: number;
  total?: number;
}) {
  return (
    <Flex bg={colors.black75} roundedBottom={15} px={4} h="50px" align="center">
      {totalItens ? <Flex fontWeight="bold" flex={1}></Flex> : null}
      {total ? <Flex fontWeight="bold">{formatMoney(total)}</Flex> : null}
    </Flex>
  );
}
